// import scorecardReducer from './reducer';
export const scorecardActionsType = {
    FETCH_SUCCESSFULL: "Fetch_Request_Successfull",
    FETCH_FAILURE: 'Fetch_Request_Failed'
}
export const RISK_GRADES = 'src/components/Scorecard/Create/action/Risk_Grades';
export const setRiskGrades = (data) => {
    return {
        type: RISK_GRADES,
        data
    }
}
export const REQUEST_BODY = 'src/components/Scorecard/Create/action/Request_Body';
export const EDIT_SCORECARD_SUCCESS = 'src/components/Scorecard/Create/action/Edit_Scorecard_Success';
export const EDIT_SCORECARD_FAILURE = 'src/components/Scorecard/Create/action/Edit_Scorecard_Failure';
export const setRequestBody = (data) => {
    return {
        type: REQUEST_BODY,
        data
    }
}
export const editScorecardSuccess = (data) => {
    return {
        type: EDIT_SCORECARD_SUCCESS,
        data
    }
}
export const editScorecardError = (data) => {
    return {
        type: EDIT_SCORECARD_FAILURE,
        data
    }
}
export const CREATE_REQUEST_BODY = 'src/components/Scorecard/Create/action/Create_Request_Body';
export const SCORECARD_SUCCESS = 'src/components/Scorecard/Create/action/Scorecard_Success';
export const SCORECARD_FAILURE = 'src/components/Scorecard/Create/action/Scorecard_Failure';
export const setCreateRequestBody = (data) => {
    return {
        type: CREATE_REQUEST_BODY,
        data
    }
}
export const createScorecardSuccess = (data) => {
    return {
        type: SCORECARD_SUCCESS,
        data
    }
}
export const createScorecardFailure = (data) => {
    return {
        type: SCORECARD_FAILURE,
        data
    }
}

export const SCORECARD_DETAILS_SUCCESS = 'src/components/Scorecard/Create/action/Scorecard_Details_Success';
export const SCORECARD_DETAILS_FAILURE = 'src/components/Scorecard/Create/action/Scorecard_Details_Failure';
export const SCORECARD_ID = 'src/components/Scorecard/Create/action/Scorecard_Id';
export const getScorecardDetails = (data) => {
    return {
        type: SCORECARD_DETAILS_SUCCESS,
        data
    }
}
export const getScorecardDetailsFailure = (data) => {
    return {
        type: SCORECARD_DETAILS_FAILURE,
        data
    }
}

export const setScorecardId = (data) => {
    return {
        type: SCORECARD_ID,
        data
    }
}
export const FINANCIAL_DATA = 'src/components/Scorecard/Create/action/Financial_Data';
export const NON_FINANCIAL_DATA = 'src/components/Scorecard/Create/action/Non_Financial_Data';
export const OVERRIDDEN_DATA = 'src/components/Scorecard/Create/action/Overridden_Data';
export const VALIDATION_FLAG = 'src/components/Scorecard/Create/action/Validation_Flag';
export const setFinancialData = (data) => {
    return {
        type: FINANCIAL_DATA,
        data
    }
}
export const setNonFinancialData = (data) => {
    return {
        type: NON_FINANCIAL_DATA,
        data
    }
}
export const setOverriddenData = (data) => {
    return {
        type: OVERRIDDEN_DATA,
        data
    }
}
export const setValidationFlag = (data) => {
    return {
        type: VALIDATION_FLAG,
        data
    }
}

export const SCORECARD_INITIAL_VALUES = 'src/components/Scorecard/Create/action/Scorecard_Initial_Value';

export const setScorecardFormInitialValue = (data) => {
    return {
        type: SCORECARD_INITIAL_VALUES,
        data
    }
}
export const CORPORATE_MODAL = 'src/components/Scorecard/Create/action/Corporate_Modal';

export const setcorporateModal = () => {
    return {
        type: CORPORATE_MODAL
    }
}

export const SEARCH_CORPORATE_PARAMETER_SCORECARD = 'src/components/Scorecard/Create/action/Search_Param';
export const setSearchCorporateParameterScorecard = (parameter,search) => {
    return {
        type: SEARCH_CORPORATE_PARAMETER_SCORECARD,
        search,
        parameter
    }
}
export const SEARCH_CORPORATE_RESULTS_SCORECARD_SUCCESS = 'src/components/Scorecard/Create/action/Search_Param_ScoreCard_Success';
export const SEARCH_CORPORATE_RESULTS_SCORECARD_FAILURE = 'src/components/Scorecard/Create/action/Search_Param_ScoreCard_Failure';
export const searchCorporateResultsScorecardSuccess = (data) => {
    return {
        type: SEARCH_CORPORATE_RESULTS_SCORECARD_SUCCESS,
        data
    }
}
export const searchCorporateResultsScorecardFailure = (error) => {
    return {
        type: SEARCH_CORPORATE_RESULTS_SCORECARD_FAILURE,
        error
    }
}